export enum RanksTabkey {
  BOUNTY_LEADERBOARD = 'BOUNTY_LEADERBOARD',
  HACKER_ADDRESS = 'HACKER_ADDRESS',
  VERIFYREPORTS = 'VERIFYREPORTS',
}
